import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';
import * as React from 'react'

// 创建QueryClient实例
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 在开发环境启用缓存
      staleTime: import.meta.env.PROD ? 5 * 60 * 1000 : 60 * 1000, // 5分钟（生产）/ 1分钟（开发）
      retry: 1, // 失败后重试1次
      refetchOnWindowFocus: false, // 窗口聚焦时不自动重新获取数据
      refetchOnReconnect: true, // 网络重连时重新获取数据
    },
    mutations: {
      retry: 1, // 失败后重试1次
    },
  },
});

// React Query Provider组件
export const QueryProvider = ({ children }: { children: ReactNode }) => {
  return React.createElement(
    QueryClientProvider,
    { client: queryClient },
    children,
    import.meta.env.DEV && React.createElement(ReactQueryDevtools, { initialIsOpen: false })
  );
};